<template>
	<div id="navegacion">
		<a href="javascript:void(0)" id="titulo">
			<img v-if="value.logotipo" :src="value.logotipo" title="Pulsa para cambiar el logotipo" @click="cambiarLogotipo = true">
			<v-tooltip v-else bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-avatar v-bind="attrs" v-on="on" @click="cambiarLogotipo = true">
						<v-icon dark>mdi-image-plus</v-icon>
					</v-avatar>
				</template>
				<span>Agrega un logotipo al sitio</span>
			</v-tooltip>
			<span>
				<v-text-field
					v-model="value.título"
					color="white"
					single-line
					dark
					label="Escribe aquí el título del sitio"
					style="font-size: 20px"
					dense
					autofocus
				></v-text-field>
			</span>
		</a>

		<v-spacer></v-spacer>

		<Menu v-model="value.menú" :páginas="value.otras_páginas" @página="$emit('página', $event)"></Menu>

		<v-dialog
      v-model="cambiarLogotipo"
      max-width="800"
    >
      <seleccionar-medio v-model="logotipo" @hecho="cambiarLogotipo = false"></seleccionar-medio>
    </v-dialog>

	</div>
</template>

<script>

import SeleccionarMedio from '@/components/utilidades/SeleccionarMedio'
import Menu from '@/components/constructor/Sitio/Menu'

export default {
  name: 'Navegacion',

  data: () => ({
		cambiarLogotipo: false,
		logotipo: {
			tipo: 'imagen',
			ubicación: ''
		},
	}),

	components: {
		SeleccionarMedio,
		Menu
	},
	
	props: {
		value: {
			type: Object
		}
	},

	watch: {
		'logotipo.ubicación': function(val) {
			this.$set(this.value, 'logotipo', (val || ''))
			if (val) {
				this.cambiarLogotipo = false
			}
		}
	},

};

</script>

<style scoped>
#navegacion {
	position: absolute !important;
	z-index: 1 !important;
}

</style>